/**
 * Check if user is authenticated by verifying with the backend.
 * On 401, tries token refresh then retries auth/me (handles transient instance key mismatch on Vercel).
 */
export const checkAuthentication = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

    const tryAuthMe = () =>
        fetch(`${apiUrl}/v1/auth/me`, { credentials: 'include' });

    const tryRefresh = () =>
        fetch(`${apiUrl}/v1/auth/refresh`, {
            method: 'POST',
            credentials: 'include',
        });

    try {
        let response = await tryAuthMe();

        // On 401, try refresh then retry auth/me (resilience for serverless instance mismatch)
        if (response.status === 401) {
            const refreshRes = await tryRefresh();
            if (refreshRes.ok) {
                response = await tryAuthMe();
            }
        }

        if (!response.ok) {
            return false;
        }

        const userData = await response.json();
        localStorage.setItem('currentUser', JSON.stringify(userData));
        return true;
    } catch (error) {
        console.error('Auth check failed:', error);
        return false;
    }
};

/**
 * Handle authentication failure - clear local data and redirect to login
 */
export const handleAuthFailure = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('hasLoggedIn');
    localStorage.removeItem('selectedFamilyId');
    window.location.href = '/login';
};

